export const calculateWindowSize = (windowWidth: number) => {
  if (windowWidth >= 1200) {
    return 'lg';
  }
  if (windowWidth >= 992) {
    return 'md';
  }
  if (windowWidth >= 768) {
    return 'sm';
  }
  return 'xs';
};

export const setWindowClass = (classList: string) => {
  const window: HTMLElement | null =
    document && document.getElementById('root');
  if (window) {
    window.className = (classList);
  }
};
export const addWindowClass = (classList: string) => {
  const window: HTMLElement | null =
    document && document.getElementById('root');
  if (window) {
    window.classList.add(classList);
  }
};

export const removeWindowClass = (classList: string) => {
  const window: HTMLElement | null =
    document && document.getElementById('root');
  if (window) {
    window.classList.remove(classList);
  }
};

export const hoje = () => {
  const data = new Date().toLocaleString().split(',')[0].split("/")
  return data[2] + "-" + data[1] + "-" + data[0]
}


export const primeiroDiaDoMesAtual = () => {
  const data = new Date().toLocaleString().split(',')[0].split("/")
  return data[2] + "-" + data[1] + "-" + "01"
}
